import { render } from "./SwapCardContent.vue?vue&type=template&id=767b0228&scoped=true"
import script from "./SwapCardContent.vue?vue&type=script&lang=js"
export * from "./SwapCardContent.vue?vue&type=script&lang=js"

import "./SwapCardContent.vue?vue&type=style&index=0&id=767b0228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767b0228"]])

export default __exports__